import { gql } from '@apollo/client';

export const DELETE_VORLAGE_ABSCHNITT = gql`
  mutation mitarbeiter_deleteVorlageAbschnitt(
    $vorlageAbschnittId: String!
    $vorlageId: String!
    $position: Int!
  ) {
    mitarbeiter_deleteVorlageAbschnitt(
      vorlageAbschnittId: $vorlageAbschnittId
      vorlageId: $vorlageId
      position: $position
    ) {
      success {
        vorlageAbschnittId
      }
      error {
        message
      }
    }
  }
`;
